/**
 * Unions listing gallery + draft listing-variant assets by id (publish scope).
 *
 * @param {Object[]} [galleryAssets]
 * @param {Object[]} [variantAssets]
 * @returns {Object[]}
 */
export default function collectDraftPublishAssets(galleryAssets = [], variantAssets = []) {
  const byId = new Map();

  [...(galleryAssets || []), ...(variantAssets || [])].forEach((asset) => {
    if (!asset?._id) return;
    byId.set(String(asset._id), asset);
  });

  return [...byId.values()];
}
